import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WaterInfoImageType } from '@models/water-image-types';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageFieldComponent } from '@shared/components/image-picker/image-field.component';
import { LocalizedTextEditorComponent } from '@shared/components/localized-text-editor/localized-text-editor.component';
import type { LocationForm } from '../water-information-form.types';

@Component({
  selector: 'app-water-information-location-section',
  templateUrl: './water-information-location-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    TranslatePipe,
    ImageFieldComponent,
    LocalizedTextEditorComponent,
  ],
})
export class WaterInformationLocationSectionComponent {
  @Input({ required: true }) form!: FormGroup<LocationForm>;

  readonly mapImageName = input.required<string | null>();
  readonly mapImageUrl = input.required<string | null>();
  readonly locationImageName = input.required<string | null>();
  readonly locationImageUrl = input.required<string | null>();

  readonly uploadImage = output<{ type: WaterInfoImageType; file: File }>();
  readonly deleteImage = output<WaterInfoImageType>();

  protected readonly WaterInfoImageType = WaterInfoImageType;
}
